import { SOCIAL_PLATFORMS, type VenueSocial } from '../../../../api/venues';
import { Field } from '../venueCreateFields';

import { Input } from './Input';
import { socialErrorKey, type SocialDraft } from './social-form';
import { SocialPlatformForm } from './SocialPlatformForm';

interface SocialEditFormProps {
  draft: SocialDraft;
  onChange: (next: SocialDraft) => void;
  errors: Record<string, string>;
  /** What the venue holds now, for the last-verified stamps. */
  social: VenueSocial | null;
  compact: boolean;
}

/** Edit form for all three platforms and the website. */
export function SocialEditForm({ draft, onChange, errors, social, compact }: SocialEditFormProps) {
  const websiteError = errors[socialErrorKey('website')];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {SOCIAL_PLATFORMS.map((platform) => (
        <SocialPlatformForm
          key={platform}
          platform={platform}
          draft={draft[platform]}
          onChange={(next) => onChange({ ...draft, [platform]: next })}
          errors={errors}
          verifiedAt={social?.[platform]?.lastVerifiedAt}
          compact={compact}
        />
      ))}
      <Field label="Website" error={websiteError}>
        <Input
          mono
          value={draft.website}
          onChange={(v) => onChange({ ...draft, website: v })}
          placeholder="example.com"
          error={websiteError !== undefined}
          style={{ maxWidth: 360 }}
        />
      </Field>
      <div style={{ fontSize: 10.5, color: 'var(--nb-muted)', lineHeight: 1.45 }}>
        Saving stamps <b>last verified</b> on each platform you changed. Blank audience or cadence
        means unknown, never zero.
      </div>
    </div>
  );
}
